import { useApi, apiResolver } from "@/api/useApi";
import { useMemo } from "react";
import {
  AccessLabelsResponse,
  AssignLabelsRequest,
  DeleteLabelsRequest,
  SetLabelsRequest,
  AccessLabelApiResponse,
} from "./AccessLabel.model";

export function useAccessLabelApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getAccessLabels: async () =>
        apiResolver<AccessLabelsResponse>(
          api.get("/knowledge-base-handler/access-labels")
        ),
      assignLabels: async (request: AssignLabelsRequest) =>
        apiResolver<AccessLabelApiResponse>(
          api.post("/knowledge-base-handler/access-labels/assign", request)
        ),
      deleteLabels: async (request: DeleteLabelsRequest) =>
        apiResolver<AccessLabelApiResponse>(
          api.post("/knowledge-base-handler/access-labels/delete", request)
        ),
      setLabels: async (request: SetLabelsRequest) =>
        apiResolver<AccessLabelApiResponse>(
          api.post("/knowledge-base-handler/access-labels/set", request)
        ),
    }),
    [api]
  );
}
